<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      :color="barColor"
      dark
      fixed
    >
      <v-btn
        v-if="!header.menus && $route.name !== 'selection'"
        icon
        active-class="v-item--disabled"
        :to="{name: 'selection'}"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        v-if="header.menus && header.menus.length"
        @click.stop="clickNavIcon"
      />

      <v-toolbar-title
        style="width: 300px; cursor: pointer"
        class="ml-0 pl-4"
        @click="$router.push({ name: header.title.cta }).catch((err) => {})"
      >
        <div class="d-flex justify-start align-center">
          <v-img
            class="mr-2"
            src="@/assets/branding/gcg_logo.png"
            contain
            max-width="105"
            height="30"
          />
          <span class="hidden-sm-and-down">
            {{ header.title.text }}
          </span>
        </div>
      </v-toolbar-title>

      <v-text-field
        v-if="header.search"
        v-model="searchInputText"
        flat
        solo-inverted
        hide-details
        append-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
        @keydown.enter="searchInput"
        @click:append="searchInput"
      />

      <v-spacer />

      <v-overflow-btn
        v-if="header.platforms && header.platforms.list"
        v-model="selectedPlatform"
        :items="header.platforms.list"
        hide-details
        style="max-width: 250px; border-radius: 4px;"
        class="mr-3"
        :tile="false"
        :background-color="$vuetify.theme.dark ? 'grey darken-2' : 'primary lighten-1'"
        :item-color="$vuetify.theme.dark ? 'grey lighten-4' : 'grey darken-4'"
        flat
      />

      <v-menu
        v-if="header.downloads && header.downloads.length"
        offset-y
      >
        <template #activator="{ on }">
          <v-btn
            dark
            icon
            v-on="on"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, key) in header.downloads"
            :key="`Download${key}`"
            @click="downloadSource(item.href)"
          >
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!--<v-btn
        icon
        @click="toggleDarkMode"
      >
        <v-icon v-if="$vuetify.theme.dark">
          mdi-brightness-4
        </v-icon>
        <v-icon v-else>
          mdi-brightness-7
        </v-icon>
      </v-btn>-->

      <ServiceSelection class="mr-2" />

      <AccountMenu />
    </v-app-bar>

    <DrawerMenu
      v-if="header.menus && header.menus.length"
      :menus="header.menus"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import DrawerMenu from './DrawerMenu.vue';
import AccountMenu from './AccountMenu.vue';
import ServiceSelection from './ServiceSelection.vue';

export default {
  components: {
    DrawerMenu,
    AccountMenu,
    ServiceSelection,
  },

  props: {
    // ## Header structure ##
    //
    // DashboardName: {
    //   title: {'text', 'cta'}
    //   menus(Drawer): [{'text', 'icon', to:{name: 'routerName'}}]
    //   search: 'searchRouterName'
    //   platform: {init: 'defaultSelected', list: ['selectablePlatformNames']}
    //   downloads: [{'fileTitle', 'S3link'}]
    // }
    header: {
      type: Object,
      default: () => ({
        title: {
          text: 'MAM Dashboard',
          cta: '',
        },
        menus: null,
        searchRoute: null,
        platforms: null,
        downloads: null,
      }),
    },
  },

  data: () => ({
    searchInputText: '',
  }),

  computed: {
    barColor() {
      if (this.$vuetify.theme.dark) {
        return '';
      }
      return 'primary';
    },

    selectedPlatform: {
      get() {
        return this.header.platforms.init;
      },
      set(newValue) {
        this.$emit('update:header.platforms.init', newValue);
      },
    },
  },

  methods: {
    ...mapMutations('displaySettings', [
      // 'toggleDarkMode',
      'toggleExpandDrawerOnHover',
      'toggleShowDrawer',
    ]),

    ...mapMutations('common', [
      'updateSearch',
    ]),

    clickNavIcon() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.toggleExpandDrawerOnHover();
      } else {
        this.toggleShowDrawer();
      }
    },

    searchInput() {
      this.updateSearch(this.searchInputText);
      this.$router.push({
        name: this.header.search,
        query: {
          search: this.searchInputText,
        },
      }).catch(() => {});
    },

    downloadSource(href) {
      window.location.href = href;
    },
  },
};
</script>
